/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  MenuItem
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import { ValidateCompany } from '../../assets/validation';
import CompanyAction from '../../store/actions/CompanyAction';
import globalAction from '../../store/actions/GlobalAction';

function CompanyEdit({ itemId, openmodal, onCloseModal }) {
  const dispatch = useDispatch();

  // Replace 'data' with your reducer name
  const { companyItemData, isLoading } = useSelector((state) => state.company);
  const { statusData } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(CompanyAction.getItem(itemId));
    dispatch(globalAction.getClientStatus());
  }, [dispatch, itemId]);
  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      //   aria-labelledby="modal-modal-title"
      //   aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik
          initialValues={{
            name: companyItemData && companyItemData?.name ? companyItemData.name : '',
            status: companyItemData && companyItemData?.status ? companyItemData.status : ''
          }}
          enableReinitialize
          validationSchema={ValidateCompany}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            dispatch(CompanyAction.update(itemId, values, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Edit Company"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="Company Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter Company Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-department" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="status"
                    fullWidth
                    label="Status"
                    name="status"
                    margin="normal"
                    select
                    value={values.status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.status && touched.status}
                    helperText={errors.status && touched.status && errors.status}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-arrow-down" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  >
                    {statusData &&
                      statusData.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.status}
                        </MenuItem>
                      ))}
                  </TextField>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

CompanyEdit.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default CompanyEdit;
